import nightTulips from '../assets/images/painting-night-tulip-2025.webp'
import prairie from '../assets/images/painting-prairie-2025.webp'

import snakesHide from '../assets/images/painting-snakes-hide-2023.webp'

import houseMisty from '../assets/images/painting-house-misty.-2022webp.webp'
import daytimeVacancies from '../assets/images/painting-daytime-vacancies-2022.webp'
import eyeStorm from '../assets/images/painting-eye-storm-2022.webp'
import storySplinter from '../assets/images/painting-story-splinter-2022.webp'

import leopardTranspirings from '../assets/images/painting-leopard-transpirings-2021.webp'
import lettuceGarden from '../assets/images/painting-lettuce-garden-2021.webp'
import lightFolding from '../assets/images/painting-light-folding-2021.webp'
import rubiesSternum from '../assets/images/painting-rubies-sternum-2021.webp'

import oldPearls from '../assets/images/painting-old-pearls-2020.webp'
import rendezvous1 from '../assets/images/painting-rendezvous1-2020.webp'
import rendezvous2 from '../assets/images/painting-rendezvous2-2020.webp'

export const paintingImages = [
    {
        src: nightTulips,
        alt: "",
        title: "Night Tulips",
        dimension: '19.5" x 15.5"',
        material: "Acrylic, house paint, and pastel on wood",
        year: "2025"
    }, 
    {
        src: prairie,
        alt: "",
        title: "Prairie",
        dimension: '20" x 15.5"',
        material: "Acrylic, house paint, sand, glitter, and pencil on wood",
        year: "2025"
    }, 
    {
        src: snakesHide,
        alt: "",
        title: "Where Old Snakes Hide",
        dimension: '30.5" x 30"',
        material: "Acrylic and pastel on wood",
        year: "2023"
    },   
    {
        src: houseMisty,
        alt: "",
        title: "House on the misty hill (loose snake on the run)",
        dimension: '3" x 28"',
        material: "Acrylic, pastel and oil gesso on fabric",
        year: "2022"
    }, 
    {
        src: daytimeVacancies,
        alt: "",
        title: "Daytime Vacancies",
        dimension: '18" x 24"',
        material: "Oil aint and color pencil on wood",
        year: "2022"
    },
    {
        src: storySplinter,
        alt: "",
        title: "Story of a Splinter",
        dimension: '18" x 24"',
        material: "Oil, ink, and charcoal on wood panel",
        year: "2022"
    },
    {
        src: eyeStorm,
        alt: "",
        title: "Eye of the storm",
        dimension: '',
        material: "Oil paint, soft pastel and thread on leathered fabric",
        year: "2022"
    },
    {
        src: lightFolding,
        alt: "",
        title: "Light of folding screen",
        dimension: '45" x 50"',
        material: "Oil paint, conte, ink and hanji on paper",
        year: "2021"
    },
    {
        src: lettuceGarden,
        alt: "",
        title: "Lettuce garden charm",
        dimension: '18" x 24"',
        material: "Oil paint and oil pastel on canvas",
        year: "2021"
    },
    {
        src: rubiesSternum,
        alt: "",
        title: "Rubies in the sternum",
        dimension: '17" x 31"',
        material: "Oil paint, ink, soft pastel, and glitter on paper",
        year: "2021"
    },
    {
        src: leopardTranspirings,
        alt: "",
        title: "Leopard Transpirings",
        dimension: '14" x 21"',
        material: "Oil paint, ink and shellac on paper",
        year: "2021"
    }, 
    {
        src: oldPearls,
        alt: "",
        title: "Old Pearls",
        dimension: '8" x 11"',
        material: "Oil paint and oil pastel on canvas",
        year: "2020"
    },
    {
        src: rendezvous1,
        alt: "",
        title: "Rendezvous I",
        dimension: '11" x 8"',
        material: "Oil paint on masonite",
        year: "2020"
    },
    {
        src: rendezvous2,
        alt: "",
        title: "Rendezvous II",
        dimension: '8" x 11"',
        material: "Oil paint on masonite",
        year: "2020"
    },
]